import { render } from "./CreateTransferPage.vue?vue&type=template&id=7929cefe&scoped=true"
import script from "./CreateTransferPage.vue?vue&type=script&lang=js"
export * from "./CreateTransferPage.vue?vue&type=script&lang=js"

import "./CreateTransferPage.vue?vue&type=style&index=0&id=7929cefe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7929cefe"]])

export default __exports__